import React from 'react';
import ReactDOM from 'react-dom/client';
import AnimalFact from './AniamalFact';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AnimalFact />
  </React.StrictMode>
);

